import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import App from './containers/App/Loadable';
import StoreProvider from './store/StoreProvider';
import './index.css';
import './i18n';
import { setNavigator } from './services/navigationService';

function NavigatorSetter() {
  const nav = useNavigate();
  setNavigator(nav);
  return null;
}

console.log('currently running verions: 1.1');
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <StoreProvider>
    <BrowserRouter>
      <NavigatorSetter />
      <App />
    </BrowserRouter>
  </StoreProvider>,
);
